export default __webpack_public_path__ + "static/media/data-collection (1).33b8fde4.svg";